import * as CONSTANTS from "../constants";

/** Base class for roles
 * Class BaseRole
 */
export class BaseRole {
    ready;
    actionsLeftThisRound;
    usernames = [''];

    constructor() {
        this.ready = false;
        this.actionsPerRound = CONSTANTS.ACTIONS_PER_ROUND_PER_ROLE;
        this.actionsLeftThisRound = this.actionsPerRound;
    }

    getView(storage, gameInProgress) {
        throw new Error('getView() must be implemented');
    }

    canUseAction() {
        return this.actionsLeftThisRound > 0;
    }

    resetActions() {
        this.actionsLeftThisRound = this.actionsPerRound;
    }

    useAction() {
        if (this.actionsLeftThisRound <= 0) {
            throw new Error('No actions left this round');
        }
        this.actionsLeftThisRound--;
    }

    addActions(numActions) {
        this.actionsLeftThisRound += numActions;
    }

    import(data) {
        for (let key of Object.keys(data)) {
            this[key] = data[key];
        }
    }

    static newFromData(data) {
        throw new Error('newFromData() must be implemented');
    }
}